document.addEventListener('click', function (e) {

  // Text popup open
        const askQuoteBtn = e.target.closest('.ask_quote_link');
        if (askQuoteBtn) {
          const targetId = askQuoteBtn.getAttribute('data-id');
          const targetPopup = document.getElementById(targetId);

          if (targetPopup) {
            targetPopup.classList.add('active');
            document.body.classList.add('overflow_hidden');
          }
          return;
        }
        
  // If the clicked element is inside .icon_image li
  const clickedIcon = e.target.closest('.icon_image li');
  if (clickedIcon) {
    const targetId = clickedIcon.getAttribute('data-id');

    // Only proceed if there are popups
    const allPopups = document.querySelectorAll('.link_popup');
    if (allPopups.length > 0) {
      allPopups.forEach(popup => popup.classList.remove('active'));

      const targetPopup = document.getElementById(targetId);
      if (targetPopup) {
        targetPopup.classList.add('active');
        document.body.classList.add('overflow_hidden');
      }
    }

    return;
  }

  // Close popup if clicked on close icon
  if (e.target.closest('.close_popup, .cancel_btn')) {
    const activePopups = document.querySelectorAll('.link_popup.active, .remove_cart_popup.active');
    activePopups.forEach(popup => popup.classList.remove('active'));
    document.body.classList.remove('overflow_hidden');
    return;
  }

  // Click outside modal to close
  const activePopups = document.querySelectorAll('.link_popup.active');
  activePopups.forEach(popup => {
    const modal = popup.querySelector('.modal_wrapper');
    if (modal && !modal.contains(e.target)) {
      popup.classList.remove('active');
      document.body.classList.remove('overflow_hidden');
    }
  });

  if (e.target.closest('.apply-coverage')) {
    const popup = e.target.closest('.link_popup');
    if (popup) {
      const totalValue = popup.querySelector('.total_value strong');
      const sqftInput = document.querySelector('.coverage-with-boxes-wrapper #sqft');
      const wastageCheckbox = document.querySelector('.wastage-checkbox input[type="checkbox"]');

      if (totalValue && sqftInput) {
        let value = parseFloat(totalValue.textContent.replace(/,/g, '')) || 0;

        // Apply 10% wastage if checkbox is checked
        if (wastageCheckbox && wastageCheckbox.checked) {
          value = (value * 1.1);
        }

        sqftInput.value = value.toFixed(2);

        // Trigger events
        sqftInput.dispatchEvent(new Event('input', { bubbles: true }));
        sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Close popup and unlock scroll
      popup.classList.remove('active');
      document.body.classList.remove('overflow_hidden');
    }
  }
});

// Function to create a new row
function createAreaRow() {
  const row = document.createElement('div');
  row.classList.add('product_mm_fld', 'flex', 'items-center', 'gap-x-2');
  row.innerHTML = `
    <div class="field_grp">
      <input type="number" placeholder="0" class="input_fld length_input" />
      <label>Length (ft)</label>
    </div>
    <div class="field_grp">X</div>
    <div class="field_grp">
      <input type="number" placeholder="0" class="input_fld width_input" />
      <label>Width (ft)</label>
    </div>
    <div class="field_grp">=</div>
    <div class="field_grp">
      <input type="number" placeholder="0" class="input_fld area_output" readonly />
      <label>Sq. ft.</label>
    </div>
  `;
  return row;
}

// Safe check for form layout
const form = document.querySelector('.form_layout form');

if (form) {
  const addMoreLink = form.querySelector('.add_more_link a');
  const totalCoverageEl = form.querySelector('.total_value strong');

  if (addMoreLink && totalCoverageEl) {
    // Event: Add new row on link click  
    let fieldSetCount = 1;
    addMoreLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (fieldSetCount >= 10) return;
      const newRow = createAreaRow();
      form.insertBefore(newRow, addMoreLink.parentElement);
      setupCalculation(newRow);
      fieldSetCount++;
      if (fieldSetCount >= 10) {
        addMoreLink.style.display = 'none'; // hide the button
      }
    });
    // Function to recalculate total
    function calculateTotal() {
      let total = 0;
      const areaFields = form.querySelectorAll('.area_output');
      areaFields.forEach(field => {
        total += Number(field.value || 0);
      });
      totalCoverageEl.textContent = total.toLocaleString();
    }

    // Setup calculation for a row
    function setupCalculation(row) {
      const lengthInput = row.querySelector('.length_input');
      const widthInput = row.querySelector('.width_input');
      const areaOutput = row.querySelector('.area_output');

      const calculate = () => {
        const length = parseFloat(lengthInput.value) || 0;        
        const width = parseFloat(widthInput.value) || 0;
        const area = length * width;
        areaOutput.value = area;
        calculateTotal();
      };

      lengthInput.addEventListener('input', calculate);
      widthInput.addEventListener('input', calculate);
    }

    // Initialize calculations for existing rows
    const initialRows = form.querySelectorAll('.product_mm_fld');
    initialRows.forEach(row => setupCalculation(row));
  }
}

// 10% wastage

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.product .coverage-with-boxes-input-main');
  if (!wrapper) return;

  const sqftInput = document.getElementById('sqft');
  const boxesInput = document.getElementById('boxes');
  const wastageCheckbox = document.querySelector('.wastage-checkbox input[type="checkbox"]');
  const errorDiv = document.querySelector('.error-add');
  const calculatorWrapper = document.querySelector('#product-calculator');
  const totalPriceElement = document.getElementById('total-price');
  const coverageMessage = document.getElementById('product-coverage');
  const oneBoxPrice = parseFloat(wrapper.getAttribute('one-box-price')) / 100 || 0; // Convert from cents to dollars


  if (!sqftInput || !boxesInput || !wastageCheckbox) return;

  const sqftPerBox = parseFloat(wrapper.dataset.sqftPerBox) || 1;
  let rawSqft = 0; // Track sqft before wastage
  let manualSqftValue = 0;
  let isSyncing = false;

  // Helper: Clear error
  function clearError() {
    if (calculatorWrapper && errorDiv) {
      calculatorWrapper.classList.remove('error-box');
      errorDiv.innerHTML = '';
      errorDiv.style.display = 'none';
    }
  }

  // Helper: Show error
  function showError(message) {
    if (!calculatorWrapper || !errorDiv) return;

    const errorIcon = `
      <svg height="20" width="20" style="overflow:visible;enable-background:new 0 0 32 32; vertical-align: middle; margin-right: 6px;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <g id="Error_1_">
          <g id="Error">
            <circle cx="16" cy="16" r="16" style="fill:#D72828;" />
            <path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" style="fill:#E6E6E6;" />
          </g>
        </g>
      </svg>
    `;
    errorDiv.innerHTML = `
      <div class="error-msg" style="display:flex; align-items:center; gap: 6px;">
        ${errorIcon}<span>${message}</span>
      </div>
    `;
    errorDiv.style.display = 'block';
    calculatorWrapper.classList.add('error-box');
  }

  // Helper: Update total price and coverage visibility
  function updateTotalAndCoverage() {
    const boxes = parseFloat(boxesInput.value) || 0;
    const total = boxes * oneBoxPrice;
    totalPriceElement.textContent = `$${total.toFixed(2)}`;

    if (boxes > 0) {
      coverageMessage.style.display = 'none';
    } else {
      coverageMessage.style.display = 'block';
    }
  }


if (wastageCheckbox && sqftInput && boxesInput) {
  wastageCheckbox.addEventListener('change', function () {
    let sqft = parseFloat(sqftInput.value) || 0;
    let boxes = parseFloat(boxesInput.value) || 0;

    if (this.checked && sqft <= 0 && boxes <= 0) {
      this.checked = false;
      showError('Please enter a valid Sqft or Boxes before applying 10% wastage.');
      isSyncing = false; // ✅ release lock if set
      return;            // stop without breaking inputs
    }
  });
}

// SQFT → BOXES
sqftInput.addEventListener('input', function () {
  clearError();
  if (isSyncing) return;
  isSyncing = true;
  

  let sqft = parseFloat(sqftInput.value) || 0;

  // Store correct manual value (no wastage)
  if (wastageCheckbox.checked) {
    manualSqftValue = sqft / 1.1; // remove wastage before storing
  } else {
    manualSqftValue = sqft;
  }
  // console.log("✏️ Stored manualSqftValue (no wastage):", manualSqftValue);

  if (wastageCheckbox.checked) {
    rawSqft = sqft / 1.1;
  } else {
    rawSqft = sqft;
  }

  if (rawSqft > 0) {
    const boxes = Math.ceil(rawSqft / sqftPerBox);
    boxesInput.value = boxes;
    boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
  } else {
    boxesInput.value = '';
    boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
  updateTotalAndCoverage();
  isSyncing = false;
});

// BOXES → SQFT
boxesInput.addEventListener('input', function () {
  clearError();
  if (isSyncing) return;
  isSyncing = true;
 

  const boxes = parseFloat(boxesInput.value) || 0;
  // console.log("📦 BOXES input changed:", boxes);

  if (boxes <= 0) {
    // console.log("❌ No boxes, clearing sqft");
    sqftInput.value = '';
    updateTotalAndCoverage();
    if (wastageCheckbox.checked) {
      wastageCheckbox.checked = false;
      showError('10% wastage removed — box quantity must be greater than 0.');
    }
    isSyncing = false;
    return;
  }

  rawSqft = boxes * sqftPerBox;
  manualSqftValue = rawSqft;
  //console.log("📏 Calculated sqft from boxes:", rawSqft, " (Manual stored:", manualSqftValue, ")");

  if (wastageCheckbox.checked) {
    sqftInput.value = (rawSqft * 1.1).toFixed(2);
    console.log("⚠️ Wastage checked → sqft:", sqftInput.value);
  } else {
    sqftInput.value = rawSqft.toFixed(2);
  }

  sqftInput.dispatchEvent(new Event('input', { bubbles: true }));
  sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
  updateTotalAndCoverage();
  isSyncing = false;
});

// WASTAGE CHECKBOX CHANGE
wastageCheckbox.addEventListener('change', function () {
  if (isSyncing) return;
  isSyncing = true;

  let sqft = manualSqftValue || 0;
  console.log("📏 Using stored manualSqftValue:", sqft);

  if (wastageCheckbox.checked) {
    sqft = sqft * 1.1; // Add 10%
    console.log("➕ Added 10% wastage → sqft:", sqft);
  } else {
    // Just revert to manual value
    console.log("➖ Removed 10% wastage → sqft:", sqft);
  }

  sqftInput.value = sqft.toFixed(2);

  const displayedSqft = parseFloat(sqftInput.value) || 0;
  const boxes = displayedSqft > 0 ? Math.ceil(displayedSqft / sqftPerBox) : '';
  console.log("📦 Updated boxes based on displayed sqft:", boxes);

  boxesInput.value = boxes;

  sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
  updateTotalAndCoverage();

  // ✅ NEW: Update actual Shopify quantity input
  const shopifyQuantityInput = document.querySelector('.quantity__input');
  if (shopifyQuantityInput) {
    shopifyQuantityInput.value = boxes;
    console.log("🛒 Shopify quantity updated →", boxes);
  }
  
  isSyncing = false;
});


  // Reset inputs on load
  boxesInput.value = boxesInput.value || '';
  sqftInput.value = sqftInput.value || '';

 // Reset total price based on pre-filled value (e.g. browser back)
    setTimeout(() => {
      const prefilledBoxes = parseFloat(boxesInput.value);
      if (prefilledBoxes > 0) {
        // Trigger syncing and total update manually
        boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        totalPriceElement.textContent = '$0.00';
        coverageMessage.style.display = 'block';
      }
    }, 50); // slight delay ensures browser autofill is complete

});


// Quantity Pass to Cart
document.addEventListener('DOMContentLoaded', function () {
  const customBoxInput = document.getElementById('boxes');
  const shopifyQuantityInput = document.querySelector('.quantity__input');

  // Run only if both inputs exist
  if (!customBoxInput || !shopifyQuantityInput) return;

  customBoxInput.addEventListener('input', function () {
    const boxValue = parseInt(customBoxInput.value);

    if (!isNaN(boxValue) && boxValue >= 1) {
      shopifyQuantityInput.value = boxValue;
    } else {
      shopifyQuantityInput.value = 0; // Fallback to minimum value
    }
  });
});


// sample button
// document.addEventListener("DOMContentLoaded", function () {
//   const sampleBtns = document.querySelectorAll(".add-second-variant");

//   if (sampleBtns.length > 0) {
//     sampleBtns.forEach(function (btn) {
//       btn.addEventListener("click", function () {
//         const variantId = this.getAttribute("data-variant-id");
//         btn.classList.add('loading'); 
//         // 🔄 Show loading spinner
//         const spinner = this.querySelector(".loading__spinner");
//         if (spinner) {
//           spinner.classList.remove("hidden");
          
//         }

//         // 🛒 Add to cart
//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             id: variantId,
//             quantity: 1
//           })
//         })
//         .then(response => {
//           if (!response.ok) {
//             throw new Error("Failed to add to cart");
//           }
//           return response.json();
//         })
//         .then(data => {
//           window.location.href = "/cart";
//         })
//         .catch(error => {
//           console.error("Error adding to cart:", error);
//           alert("Something went wrong. Please try again.");

//           // ❌ Hide spinner on error
//           if (spinner) {
//             spinner.classList.add("hidden");
//           }
//         });
//       });
//     });
//   }
// });
document.addEventListener("click", function (event) {
  const btn = event.target.closest(".add-second-variant");
  if (!btn) return; // Exit if click is not on a sample button
  if (btn.classList.contains('loading')) return; // Ignore repeat clicks while a sample is being added

  const variantId = btn.getAttribute("data-variant-id");
  btn.classList.add('loading');

  const spinner = btn.querySelector(".loading__spinner");
  if (spinner) spinner.classList.remove("hidden");

  const stopLoading = () => {
    btn.classList.remove('loading');
    if (spinner) spinner.classList.add("hidden");
  };

  // Cart-wide sample limit (assets/sample-limit.js): block the add once the total sample quantity is reached.
  const limitCheck = window.SampleLimit ? window.SampleLimit.canAdd(1) : Promise.resolve(true);

  limitCheck
    .then((allowed) => {
      if (!allowed) {
        stopLoading();
        window.SampleLimit.showAddMessage(btn);
        return;
      }

      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1,
              properties: {
                "Note": "Your sample will be a portion of the full product"
              }
             })
      })
      .then(response => {
        if (!response.ok) throw new Error("Failed to add to cart");
        return response.json();
      })
      .then(data => {
        window.location.href = "/cart";
      });
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
      alert("Something went wrong. Please try again.");
      stopLoading();
    });
});


// Quantity Validation and Error Handling
document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('boxes');
  const themeBtn = document.querySelector('.theme-btn');
  const cstBtn = document.querySelector('.cst-btn');
  const errorDiv = document.querySelector('.error-add');
  const wrapper = document.querySelector('#product-calculator');
  

  // Run script only if all required elements exist
  if (!input || !themeBtn || !cstBtn || !errorDiv || !wrapper) return;

  const isSoldOut = themeBtn.hasAttribute('disabled');

  // === On Page Load ===
  setInitialButtonState(input.value);

  // === On Input Change (toggle buttons only) ===
  input.addEventListener('input', function () {
    toggleButtons(this.value);
  });

  // === On Custom Button Click (with validation and error) ===
  cstBtn.addEventListener('click', function (e) {
    const value = input.value.trim();
    const floatVal = parseFloat(value);

    // Clear previous error
    clearError();

    // Invalid empty or zero
    if (!value || floatVal <= 0) {
      e.preventDefault();
      showError('Please enter product quantity.');
      return;
    }

    // Not a whole number
    if (!Number.isInteger(floatVal)) {
      e.preventDefault();
      const floor = Math.floor(floatVal);
      const ceil = Math.ceil(floatVal);
      showError(`Please enter a valid value. The two nearest valid values are ${floor} and ${ceil}.`);
      return;
    }

    // Valid input: simulate theme button click if not sold out
    if (!isSoldOut) themeBtn.click();
  });

  // === Helper Functions ===

  function setInitialButtonState(value) {
    const floatVal = parseFloat(value);
    if (!value || floatVal <= 0 || !Number.isInteger(floatVal)) {
      if (!isSoldOut) {
        themeBtn.hidden = true;
        cstBtn.style.display = 'block';
      }
    } else {
      if (!isSoldOut) {
        themeBtn.hidden = false;
        cstBtn.style.display = 'none';
      }
    }
  }

  function toggleButtons(value) {
    const floatVal = parseFloat(value);

    if (!value || floatVal <= 0 || !Number.isInteger(floatVal)) {
      if (!isSoldOut) {
        themeBtn.hidden = true;
        cstBtn.style.display = 'block';
      }
    } else {
      if (!isSoldOut) {
        themeBtn.hidden = false;
        cstBtn.style.display = 'none';
      }
    }

    clearError();
  }

  function clearError() {
    wrapper.classList.remove('error-box');
    errorDiv.innerHTML = '';
    errorDiv.style.display = 'none';
  }

  function showError(message) {
    const errorIcon = `
      <svg height="20" width="20" style="overflow:visible;enable-background:new 0 0 32 32; vertical-align: middle; margin-right: 6px;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <g id="Error_1_">
          <g id="Error">
            <circle cx="16" cy="16" r="16" style="fill:#D72828;" />
            <path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" style="fill:#E6E6E6;" />
          </g>
        </g>
      </svg>
    `;
    errorDiv.innerHTML = `
      <div class="error-msg" style="display:flex; align-items:center; gap: 6px;">
        ${errorIcon}<span>${message}</span>
      </div>
    `;
    errorDiv.style.display = 'block';
    wrapper.classList.add('error-box');
  }
});
 



// collection Sorting
document.querySelectorAll('.SortByWrapper').forEach((wrapper) => {
  const selected = wrapper.querySelector('.SortBySelected .selected-text');
  const options = wrapper.querySelector('.SortByOptions');
  const items = options.querySelectorAll('li');
  const sortInput = wrapper.querySelector('input[name="sort_by"]');

  const urlSort = new URLSearchParams(window.location.search).get('sort_by');

  let matchedItem = [...items].find(li => li.dataset.value === urlSort);
  if (!matchedItem) matchedItem = items[0]; 

  if (matchedItem) {
    selected.textContent = matchedItem.textContent;
    sortInput.value = matchedItem.dataset.value;

    items.forEach(item => item.classList.remove('active'));
    matchedItem.classList.add('active');
  }

  wrapper.querySelector('.SortBySelected').addEventListener('click', () => {
    const isVisible = options.style.display === 'block';

    document.querySelectorAll('.SortByOptions').forEach(opt => {
      opt.style.display = 'none';
      opt.classList.remove('open'); 
    });
  
    if (!isVisible) {
      options.style.display = 'block';
      options.classList.add('open');
    } else {
      options.style.display = 'none';
      options.classList.remove('open');
    }
  });

  items.forEach(li => {
    li.addEventListener('click', () => {
      selected.textContent = li.textContent;
      sortInput.value = li.dataset.value;

      options.style.display = 'none';
      items.forEach(item => item.classList.remove('active'));
      li.classList.add('active');

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', li.dataset.value);
      window.location.href = url.toString();
    });
  });

  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      options.style.display = 'none';
    }
  });
});


document.querySelectorAll('.header_desc').forEach(header => {
    header.addEventListener('click', function() {
        document.querySelectorAll('.header_desc').forEach(h => {
            if (h !== this) {
                h.classList.remove('active');
            }
        });
        document.querySelectorAll('.flex_wrapper_div').forEach(content => {
            if (content !== this.nextElementSibling) {
                content.style.maxHeight = '0';
            }
        });
        const content = this.nextElementSibling;
        if (content.style.maxHeight === '0px' || !content.style.maxHeight) {
            content.style.maxHeight = content.scrollHeight + 'px';
            this.classList.add('active');
        } else {
            content.style.maxHeight = '0';
            this.classList.remove('active');
        }
    });
});

// ✅ Open the first one by default
const firstHeader = document.querySelector('.header_desc');
if (firstHeader) {
    firstHeader.classList.add('active');
    const firstContent = firstHeader.nextElementSibling;
    if (firstContent) {
        firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    }
}


// document.addEventListener("DOMContentLoaded", function () {
//   const checkBtn = document.getElementById("check-btn");
//   const updateBtn = document.getElementById("update-btn");
//   const psInput = document.getElementById("ps-code");
//   const updateInput = document.getElementById("update-code");
//   const resultBox = document.getElementById("postal-result");
//   const shipCode = document.getElementById("ship-code");
//   const deliveryDate = document.getElementById("delivery-date");
//   const errorBox = document.getElementById("postal-error");
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdown = document.querySelector(".dropdown");
//   const shipWrap = document.querySelector(".ship-wrap");
//   const iconOpen = document.querySelector(".icon-open");
//   const iconClosed = document.querySelector(".icon-closed");

//   // ✅ Only continue if at least one main element exists
//   if (!checkBtn && !updateBtn && !psInput && !updateInput) return;

//   let savedCode = "";
//   let savedDate = "";

//   async function fetchDeliveryDate(code) {
//     return new Promise((resolve, reject) => {
//       setTimeout(() => {
//         if (code.match(/^\d{6}$/)) {
//           resolve("Oct 5, 2025");
//         } else {
//           reject("Invalid postal code");
//         }
//       }, 600);
//     });
//   }

//   if (checkBtn && psInput && resultBox && shipCode && deliveryDate && errorBox) {
//     checkBtn.addEventListener("click", async () => {
//       const code = psInput.value.trim();
//       errorBox.classList.add("hidden");

//       if (!code) {
//         errorBox.textContent = "Please enter a postal code.";
//         errorBox.classList.remove("hidden");
//         return;
//       }

//       try {
//         const date = await fetchDeliveryDate(code);
//         savedCode = code;
//         savedDate = date;

//         shipCode.textContent = code;
//         deliveryDate.textContent = date;
//         resultBox.classList.remove("hidden");

//         const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
//         if (buyButtons) buyButtons.classList.add("hidden-block");
//       } catch (err) {
//         errorBox.textContent = err;
//         errorBox.classList.remove("hidden");
//       }
//     });
//   }

//   if (dropdownToggle && dropdown && shipWrap) {
//     dropdownToggle.addEventListener("click", () => {
//       if (!dropdown) return;
//       const deliveryEl = document.querySelector(".delivery-date");
//       if (!deliveryEl) return;

//       if (dropdown.classList.contains("hidden")) {
//         dropdown.classList.remove("hidden");
//         deliveryEl.classList.add("hidden");
//       } else {
//         dropdown.classList.add("hidden");
//         deliveryEl.classList.remove("hidden");
//         shipCode && (shipCode.textContent = savedCode);
//         deliveryDate && (deliveryDate.textContent = savedDate);
//       }
//     });

//     shipWrap.addEventListener("click", () => {
//       if (!dropdown) return;
//       const deliveryEl = document.querySelector(".delivery-date");
//       if (!deliveryEl) return;

//       const isHidden = dropdown.classList.contains("hidden");

//       if (isHidden) {
//         dropdown.classList.remove("hidden");
//         deliveryEl.classList.add("hidden");

//         iconClosed && iconClosed.classList.add("hidden");
//         iconOpen && iconOpen.classList.remove("hidden");
//       } else {
//         dropdown.classList.add("hidden");
//         deliveryEl.classList.remove("hidden");

//         iconOpen && iconOpen.classList.add("hidden");
//         iconClosed && iconClosed.classList.remove("hidden");

//         shipCode && (shipCode.textContent = savedCode);
//         deliveryDate && (deliveryDate.textContent = savedDate);
//       }
//     });
//   }

//   if (updateBtn && updateInput) {
//     updateBtn.addEventListener("click", async () => {
//       const newCode = updateInput.value.trim();
//       errorBox && errorBox.classList.add("hidden");

//       if (!newCode) {
//         if (errorBox) {
//           errorBox.textContent = "Please enter a postal code.";
//           errorBox.classList.remove("hidden");
//         }
//         return;
//       }

//       try {
//         const date = await fetchDeliveryDate(newCode);
//         savedCode = newCode;
//         savedDate = date;

//         shipCode && (shipCode.textContent = newCode);
//         deliveryDate && (deliveryDate.textContent = date);

//         dropdown && dropdown.classList.add("hidden");
//         const deliveryEl = document.querySelector(".delivery-date");
//         deliveryEl && deliveryEl.classList.remove("hidden");
//       } catch (err) {
//         if (errorBox) {
//           errorBox.textContent = err;
//           errorBox.classList.remove("hidden");
//         }
//       }
//     });
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const checkBtn = document.getElementById("check-btn");
//   const updateBtn = document.getElementById("update-btn");
//   const psInput = document.getElementById("ps-code");
//   const updateInput = document.getElementById("update-code");
//   const resultBox = document.getElementById("postal-result");
//   const shipCode = document.getElementById("ship-code");
//   const deliveryDate = document.getElementById("delivery-date");
//   const errorBox = document.getElementById("postal-error");
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdown = document.querySelector(".dropdown");
//   const shipWrap = document.querySelector(".ship-wrap");
//   const iconOpen = document.querySelector(".icon-open");
//   const iconClosed = document.querySelector(".icon-closed");

//   if (!checkBtn && !updateBtn && !psInput && !updateInput) return;

//   let savedCode = "";
//   let savedDate = "";

//   // ✅ Get current product variant ID from page
//   const defaultVariantId = document.querySelector("[name='id']")?.value || "";

//   async function fetchDeliveryDate(code) {
//     if (!defaultVariantId) {
//       throw "Variant ID not found.";
//     }

//     const url = `https://dddemo.net/php/2025/mitesh/capitaltiles/get_delivery_dates.php?variant_id=${defaultVariantId}&end_zone=${encodeURIComponent(code)}`;

//     try {
//       const response = await fetch(url);
//       const data = await response.json();

//       if (!data.status) {
//         throw data.message || "Something went wrong!";
//       }

//       // return deliverByEnd from API
//       return new Date(data.data.deliverByEnd).toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       });
//     } catch (err) {
//       throw err;
//     }
//   }

//   function handleCheck(code) {
//     if (!code) {
//       errorBox.textContent = "Please enter a postal code.";
//       errorBox.classList.remove("hidden");
//       return;
//     }

//     errorBox.classList.add("hidden");

//     fetchDeliveryDate(code)
//       .then((date) => {
//         savedCode = code;
//         savedDate = date;

//         shipCode.textContent = code;
//         deliveryDate.textContent = date;
//         resultBox.classList.remove("hidden");

//         const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
//         if (buyButtons) buyButtons.classList.add("hidden-block");
//       })
//       .catch((err) => {
//         errorBox.textContent = err;
//         errorBox.classList.remove("hidden");
//       });
//   }

//   // ✅ Check postal code
//   if (checkBtn && psInput) {
//     checkBtn.addEventListener("click", () => {
//       handleCheck(psInput.value.trim());
//     });
//   }

//   // ✅ Update postal code
//   if (updateBtn && updateInput) {
//     updateBtn.addEventListener("click", () => {
//       handleCheck(updateInput.value.trim());

//       dropdown && dropdown.classList.add("hidden");
//       const deliveryEl = document.querySelector(".delivery-date");
//       deliveryEl && deliveryEl.classList.remove("hidden");
//     });
//   }

//   // ✅ Dropdown toggle
//   if (dropdownToggle && dropdown && shipWrap) {
//     shipWrap.addEventListener("click", () => {
//       const deliveryEl = document.querySelector(".delivery-date");
//       if (!deliveryEl) return;

//       const isHidden = dropdown.classList.contains("hidden");

//       if (isHidden) {
//         dropdown.classList.remove("hidden");
//         deliveryEl.classList.add("hidden");
//         iconClosed?.classList.add("hidden");
//         iconOpen?.classList.remove("hidden");
//       } else {
//         dropdown.classList.add("hidden");
//         deliveryEl.classList.remove("hidden");
//         iconOpen?.classList.add("hidden");
//         iconClosed?.classList.remove("hidden");
//         shipCode.textContent = savedCode;
//         deliveryDate.textContent = savedDate;
//       }
//     });
//   }
// });

// without local storage

// document.addEventListener("DOMContentLoaded", function () {
//   const checkBtn = document.getElementById("check-btn");
//   const updateBtn = document.getElementById("update-btn");
//   const psInput = document.getElementById("ps-code");
//   const updateInput = document.getElementById("update-code");
//   const resultBox = document.getElementById("postal-result");
//   const shipCode = document.getElementById("ship-code");
//   const deliveryDate = document.getElementById("delivery-date");
//   const errorBox = document.getElementById("postal-error");
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdown = document.querySelector(".dropdown");
//   const shipWrap = document.querySelector(".ship-wrap");
//   const iconOpen = document.querySelector(".icon-open");
//   const iconClosed = document.querySelector(".icon-closed");

//   if (!checkBtn && !updateBtn && !psInput && !updateInput) return;

//   let savedCode = "";
//   let savedDate = "";

//   // ✅ Get current product variant ID from PDP
//   const defaultVariantId = document.querySelector("[name='id']")?.value || "";

//   async function fetchDeliveryDate(code) {
//     if (!defaultVariantId) {
//       throw "Variant ID not found.";
//     }

//     const url = `https://dddemo.net/php/2025/mitesh/capitaltiles/get_delivery_dates.php?variant_id=${defaultVariantId}&end_zone=${encodeURIComponent(code)}`;

//     try {
//       const response = await fetch(url);
//       const data = await response.json();

//       if (!data.status) {
//         // 🛑 Handle multiple error formats
//         if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
//           throw data.errors.map(e => e.description || e.code).join(", ");
//         }
//         if (data.message) {
//           throw data.message;
//         }
//         throw "Unknown error occurred!";
//       }

//       // ✅ Return formatted deliverByEnd
//       return new Date(data.data.deliverByEnd).toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       });
//     } catch (err) {
//       // Network or parsing error fallback
//       throw typeof err === "string" ? err : "Unable to fetch delivery date.";
//     }
//   }

//   function handleCheck(code) {
//     if (!code) {
//       errorBox.textContent = "Please enter a postal code.";
//       errorBox.classList.remove("hidden");
//       return;
//     }

//     errorBox.classList.add("hidden");

//     fetchDeliveryDate(code)
//       .then((date) => {
//         savedCode = code;
//         savedDate = date;

//         shipCode.textContent = code;
//         deliveryDate.textContent = date;
//         resultBox.classList.remove("hidden");

//         const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
//         if (buyButtons) buyButtons.classList.add("hidden-block");
//       })
//       .catch((err) => {
//         errorBox.textContent = err;
//         errorBox.classList.remove("hidden");
//       });
//   }

//   // ✅ Check postal code
//   if (checkBtn && psInput) {
//     checkBtn.addEventListener("click", () => {
//       handleCheck(psInput.value.trim());
//     });
//   }

//   // ✅ Update postal code
//   if (updateBtn && updateInput) {
//     updateBtn.addEventListener("click", () => {
//       handleCheck(updateInput.value.trim());

//       dropdown && dropdown.classList.add("hidden");
//       const deliveryEl = document.querySelector(".delivery-date");
//       deliveryEl && deliveryEl.classList.remove("hidden");
//     });
//   }

//   // ✅ Dropdown toggle
//   if (dropdownToggle && dropdown && shipWrap) {
//     shipWrap.addEventListener("click", () => {
//       const deliveryEl = document.querySelector(".delivery-date");
//       if (!deliveryEl) return;

//       const isHidden = dropdown.classList.contains("hidden");

//       if (isHidden) {
//         dropdown.classList.remove("hidden");
//         deliveryEl.classList.add("hidden");
//         iconClosed?.classList.add("hidden");
//         iconOpen?.classList.remove("hidden");
//       } else {
//         dropdown.classList.add("hidden");
//         deliveryEl.classList.remove("hidden");
//         iconOpen?.classList.add("hidden");
//         iconClosed?.classList.remove("hidden");
//         shipCode.textContent = savedCode;
//         deliveryDate.textContent = savedDate;
//       }
//     });
//   }
// });

//11 with localstorage

// document.addEventListener("DOMContentLoaded", function () {
//   const checkBtn = document.getElementById("check-btn");
//   const updateBtn = document.getElementById("update-btn");
//   const psInput = document.getElementById("ps-code");
//   const updateInput = document.getElementById("update-code");
//   const resultBox = document.getElementById("postal-result");
//   const shipCode = document.getElementById("ship-code");
//   const deliveryDate = document.getElementById("delivery-date");
//   const errorBox = document.getElementById("postal-error");
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdown = document.querySelector(".dropdown");
//   const shipWrap = document.querySelector(".ship-wrap");
//   const iconOpen = document.querySelector(".icon-open");
//   const iconClosed = document.querySelector(".icon-closed");

//   if (!checkBtn && !updateBtn && !psInput && !updateInput) return;

//   let savedCode = "";
//   let savedDate = "";

//   const defaultVariantId = document.querySelector("[name='id']")?.value || "";

//   async function fetchDeliveryDate(code) {
//     if (!defaultVariantId) throw "Variant ID not found.";

//     const url = `https://dddemo.net/php/2025/mitesh/capitaltiles/get_delivery_dates.php?variant_id=${defaultVariantId}&end_zone=${encodeURIComponent(code)}`;

//     try {
//       const response = await fetch(url);
//       const data = await response.json();

//       if (!data.status) {
//         if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
//           throw data.errors.map(e => e.description || e.code).join(", ");
//         }
//         if (data.message) {
//           throw data.message;
//         }
//         throw "Unknown error occurred!";
//       }

//       return new Date(data.data.deliverByEnd).toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       });
//     } catch (err) {
//       throw typeof err === "string" ? err : "Unable to fetch delivery date.";
//     }
//   }

// async function handleCheck(code, btnEl, isUpdate = false) {
//   if (!code) {
//     errorBox.textContent = "Please enter a postal code.";
//     errorBox.classList.remove("hidden");
//     return;
//   }

//   errorBox.classList.add("hidden");

//   const loader = btnEl.querySelector(".loading__spinner");
//   const span = btnEl.querySelector("span");

//   loader?.classList.remove("hidden");
//   if (span) span.style.visibility = "hidden";

//   try {
//     const date = await fetchDeliveryDate(code);
//     savedCode = code;
//     savedDate = date;

//     shipCode.textContent = code;
//     deliveryDate.textContent = date;
//     resultBox.classList.remove("hidden");

//     localStorage.setItem("postalInfo", JSON.stringify({ code, date }));

//     const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
//     if (buyButtons) buyButtons.classList.add("hidden-block");

//     // 🔹 Only hide dropdown if API success
//     if (isUpdate && dropdown) {
//       dropdown.classList.add("hidden");
//       const deliveryEl = document.querySelector(".delivery-date");
//       deliveryEl && deliveryEl.classList.remove("hidden");
//     }

//   } catch (err) {
//     errorBox.textContent = err;
//     errorBox.classList.remove("hidden");
//     // 🔹 Do NOT hide dropdown if error
//   } finally {
//     loader?.classList.add("hidden");
//     if (span) span.style.visibility = "visible";
//   }
// }



 
// // ✅ Restore from localStorage if available
// const savedInfo = localStorage.getItem("postalInfo");
// if (savedInfo) {
//   try {
//     const { code, date } = JSON.parse(savedInfo);
//     if (code && date) {
//       savedCode = code;
//       savedDate = date;

//       shipCode.textContent = code;
//       deliveryDate.textContent = date;
//       resultBox.classList.remove("hidden");

//       // 🔹 Hide buy buttons automatically
//       const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
//       if (buyButtons) buyButtons.classList.add("hidden-block");
//     }
//   } catch (e) {
//     console.warn("Failed to parse saved postal info");
//   }
// }


//   if (checkBtn && psInput) {
//     checkBtn.addEventListener("click", () => {
//       handleCheck(psInput.value.trim(), checkBtn);
//     });
//   }

// if (updateBtn && updateInput) {
//   updateBtn.addEventListener("click", () => {
//     // isUpdate = true → dropdown hidden only on API success
//     handleCheck(updateInput.value.trim(), updateBtn, true);
//   });
// }


//   if (dropdownToggle && dropdown && shipWrap) {
//     shipWrap.addEventListener("click", () => {
//       const deliveryEl = document.querySelector(".delivery-date");
//       if (!deliveryEl) return;

//       const isHidden = dropdown.classList.contains("hidden");

//       if (isHidden) {
//         dropdown.classList.remove("hidden");
//         deliveryEl.classList.add("hidden");
//         iconClosed?.classList.add("hidden");
//         iconOpen?.classList.remove("hidden");
//       } else {
//         dropdown.classList.add("hidden");
//         deliveryEl.classList.remove("hidden");
//         iconOpen?.classList.add("hidden");
//         iconClosed?.classList.remove("hidden");
//         shipCode.textContent = savedCode;
//         deliveryDate.textContent = savedDate;
//       }
//     });
//   }
// });

// 22

document.addEventListener("DOMContentLoaded", function () {
  const checkBtn = document.getElementById("check-btn");
  const updateBtn = document.getElementById("update-btn");
  const psInput = document.getElementById("ps-code");
  const updateInput = document.getElementById("update-code");
  const resultBox = document.getElementById("postal-result");
  const shipCode = document.getElementById("ship-code");
  const deliveryDate = document.getElementById("delivery-date");
  const errorBox = document.getElementById("postal-error");
  const dropdownToggle = document.querySelector(".dropdown-toggle");
  const dropdown = document.querySelector(".dropdown");
  const shipWrap = document.querySelector(".ship-wrap");
  const iconOpen = document.querySelector(".icon-open");
  const iconClosed = document.querySelector(".icon-closed");

  if (!checkBtn && !updateBtn && !psInput && !updateInput) return;

  let savedCode = "";
  let savedDate = "";

  const defaultVariantId = document.querySelector("[name='id']")?.value || "";

  // 🔹 Normalize Canada postal codes only
  function normalizePostalCode(code) {
    if (!code) return "";

    let cleaned = code.toUpperCase().replace(/\s+/g, "");
    const caRegex = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;

    if (caRegex.test(cleaned)) {
      return cleaned.slice(0, 3) + " " + cleaned.slice(3);
    }

    // Not Canada → return trimmed as-is
    return code.trim();
  }

  async function fetchDeliveryDate(code) {
    if (!defaultVariantId) throw "Variant ID not found.";

    const url = `https://dddemo.net/php/2025/mitesh/capitaltiles/get_delivery_dates.php?variant_id=${defaultVariantId}&end_zone=${encodeURIComponent(code)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (!data.status) {
        if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
          throw data.errors.map(e => e.description || e.code).join(", ");
        }
        if (data.message) {
          throw data.message;
        }
        throw "Unknown error occurred!";
      }

      return new Date(data.data.deliverByEnd).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch (err) {
      throw typeof err === "string" ? err : "Unable to fetch delivery date.";
    }
  }

  async function handleCheck(code, btnEl, isUpdate = false) {
    // 🔹 Normalize Canada postal code first
    code = normalizePostalCode(code);

    if (!code) {
      errorBox.textContent = "Please enter a postal code.";
      errorBox.classList.remove("hidden");
      return;
    }

    errorBox.classList.add("hidden");

    const loader = btnEl.querySelector(".loading__spinner");
    const span = btnEl.querySelector("span");

    loader?.classList.remove("hidden");
    if (span) span.style.visibility = "hidden";

    try {
      const date = await fetchDeliveryDate(code);
      savedCode = code;
      savedDate = date;

      shipCode.textContent = code;
      deliveryDate.textContent = date;
      resultBox.classList.remove("hidden");

      localStorage.setItem("postalInfo", JSON.stringify({ code, date }));

      const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
      if (buyButtons) buyButtons.classList.add("hidden-block");

      if (isUpdate && dropdown) {
        dropdown.classList.add("hidden");
        const deliveryEl = document.querySelector(".delivery-date");
        deliveryEl && deliveryEl.classList.remove("hidden");
      }

    } catch (err) {
      errorBox.textContent = err;
      errorBox.classList.remove("hidden");
    } finally {
      loader?.classList.add("hidden");
      if (span) span.style.visibility = "visible";
    }
  }

  // ✅ Restore from localStorage if available
  const savedInfo = localStorage.getItem("postalInfo");
  if (savedInfo) {
    try {
      const { code, date } = JSON.parse(savedInfo);
      if (code && date) {
        savedCode = code;
        savedDate = date;

        shipCode.textContent = code;
        deliveryDate.textContent = date;
        resultBox.classList.remove("hidden");

        const buyButtons = document.querySelector(".buy_buttons-block.postal-code-wrapper");
        if (buyButtons) buyButtons.classList.add("hidden-block");
      }
    } catch (e) {
      console.warn("Failed to parse saved postal info");
    }
  }

  if (checkBtn && psInput) {
    checkBtn.addEventListener("click", () => {
      handleCheck(psInput.value.trim(), checkBtn);
    });
  }

  if (updateBtn && updateInput) {
    updateBtn.addEventListener("click", () => {
      handleCheck(updateInput.value.trim(), updateBtn, true);
    });
  }

  if (dropdownToggle && dropdown && shipWrap) {
    shipWrap.addEventListener("click", () => {
      const deliveryEl = document.querySelector(".delivery-date");
      if (!deliveryEl) return;

      const isHidden = dropdown.classList.contains("hidden");

      if (isHidden) {
        dropdown.classList.remove("hidden");
        deliveryEl.classList.add("hidden");
        iconClosed?.classList.add("hidden");
        iconOpen?.classList.remove("hidden");
      } else {
        dropdown.classList.add("hidden");
        deliveryEl.classList.remove("hidden");
        iconOpen?.classList.add("hidden");
        iconClosed?.classList.remove("hidden");
        shipCode.textContent = savedCode;
        deliveryDate.textContent = savedDate;
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".tooltip-wrapper");
  const tooltip = document.getElementById("tooltipBox");
  const closeBtn = document.getElementById("tooltipClose");

  if (!wrapper || !tooltip) return;

  // Click on whole wrapper → toggle
  wrapper.addEventListener("click", function (e) {
    e.stopPropagation();

    // prevent closing when clicking inside tooltip content
    if (e.target.closest(".tooltip-box")) return;

    tooltip.classList.toggle("active");
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      tooltip.classList.remove("active");
    });
  }

  // Click outside → close
  document.addEventListener("click", function (e) {
    if (!wrapper.contains(e.target)) {
      tooltip.classList.remove("active");
    }
  });
});


